var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuw-tag"},[_c('span',[_vm._v(_vm._s(_vm.truncate(_vm.filter, 20)))]),_c('i',{staticClass:"fal fa-times",on:{"click":function($event){return _vm.$emit('remove')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }